import layoutDefs from "./layoutDefs.json";

export const FORM_DEFINITION_LAYOUT_MODEL_URI =
  "https://rpaconnect.io/formDefinition/layout";
const formDefinitionLayoutJsonSchema = {
  uri: "https://app.rpaconnect.io/formDefinition/layout/schema.json",
  fileMatch: [FORM_DEFINITION_LAYOUT_MODEL_URI],
  schema: {
    $schema: "https://json-schema.org/draft-07/schema",
    $id: "https://app.rpaconnect.io/schemas/formDefinition/layout",
    $ref: "#/$defs/layout/Layout",
    $defs: {
      layout: layoutDefs,
    },
  },
};
export default formDefinitionLayoutJsonSchema;
